module.exports = __webpack_public_path__ + "media/icon/icon-search-f5b86d4c.svg";